import React from "react";
import "./ResidentialCommercial.scss";

const ResidentialCommercial = () => {
  return (
    <section className="residential-commercial" id="tipos-proyecto">
      <div className="residential-commercial__container">
        <div className="residential-commercial__top">
          <span className="residential-commercial__eyebrow">
            Residencial y comercial
          </span>

          <div className="residential-commercial__heading">
            <h2 className="residential-commercial__title">
              Soluciones en vidrio y aluminio para distintos tipos de espacio
            </h2>

            <p className="residential-commercial__intro">
              Desarrollamos proyectos a la medida para hogares, oficinas,
              negocios y espacios corporativos, adaptándonos a las necesidades
              funcionales y estéticas de cada cliente.
            </p>
          </div>
        </div>

        <div className="residential-commercial__grid">
          <article className="residential-commercial__card">
            <div className="residential-commercial__image-wrapper">
              <img
                src="/images/residential-project.jpg"
                alt="Proyectos residenciales en vidrio y aluminio"
                className="residential-commercial__image"
              />
            </div>

            <div className="residential-commercial__content">
              <span className="residential-commercial__label">
                Residencial
              </span>

              <h3 className="residential-commercial__card-title">
                Proyectos para casas, departamentos y remodelaciones
              </h3>

              <p className="residential-commercial__card-text">
                Creamos soluciones funcionales y modernas para espacios
                habitacionales, integrando cristal templado y aluminio en
                canceles, ventanas, puertas, barandales y más.
              </p>

              <ul className="residential-commercial__list">
                <li>Canceles de baño</li>
                <li>Ventanas y puertas de aluminio</li>
                <li>Barandales de vidrio</li>
                <li>Diseños modernos y personalizados</li>
              </ul>
            </div>
          </article>

          <article className="residential-commercial__card">
            <div className="residential-commercial__image-wrapper">
              <img
                src="/images/commercial-project.jpg"
                alt="Proyectos comerciales en vidrio y aluminio"
                className="residential-commercial__image"
              />
            </div>

            <div className="residential-commercial__content">
              <span className="residential-commercial__label">
                Comercial
              </span>

              <h3 className="residential-commercial__card-title">
                Proyectos para oficinas, locales y espacios corporativos
              </h3>

              <p className="residential-commercial__card-text">
                Atendemos proyectos comerciales que requieren presencia visual,
                resistencia y acabados profesionales, cuidando la imagen del
                negocio y la funcionalidad del espacio.
              </p>

              <ul className="residential-commercial__list">
                <li>Divisiones para oficina</li>
                <li>Fachadas y cerramientos</li>
                <li>Accesos y cancelería comercial</li>
                <li>Soluciones a medida para negocio</li>
              </ul>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
};

export default ResidentialCommercial;